import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('documentAttachmentGroups')
export class DocumentAttachmentGroup {
  @JsonProperty('code', String, true)
  public code = '';

  @JsonProperty('label', String, true)
  public label = '';

  @JsonProperty('description', String, true)
  public description = '';

  @JsonProperty('furtherDescription', String, true)
  public furtherDescription = '';

  @JsonProperty('attachmentGroup', String, true)
  public attachmentGroup = '';

  @JsonProperty('isMandatory', Boolean, true)
  public isMandatory = false;

  @JsonProperty('isList', Boolean, true)
  public isList = false;
}
